document.addEventListener("DOMContentLoaded", function() {

  const panel = document.getElementById("fabric-sample-panel");
  const overlay = document.querySelector(".fabric-panel-overlay");
  const openBtns = document.querySelectorAll(".show-sample-panel");

  if (!panel) return;

  const closeBtn = panel.querySelector(".close-panel");
  const tabButtons = panel.querySelectorAll(".tab-button");
  const tabPanels = panel.querySelectorAll(".tab-panel");

  // --- 1. 面料面板控制逻辑 (保持不变) ---
  openBtns.forEach(btn => {
    btn.addEventListener("click", function(e){
      e.preventDefault();
      panel.classList.add("open");
      overlay.style.display = "block";
      if(tabButtons.length > 0){
        tabButtons.forEach(b => b.classList.remove("active"));
        tabPanels.forEach(p => p.classList.remove("active"));
        tabButtons[0].classList.add("active");
        tabPanels[0].classList.add("active");
      }
    });
  });

  if (closeBtn) {
    closeBtn.addEventListener("click", function(e){
      e.preventDefault();
      panel.classList.remove("open");
      overlay.style.display = "none";
    });
  }

  overlay.addEventListener("click", function(){
    panel.classList.remove("open");
    overlay.style.display = "none";
  });

  tabButtons.forEach(btn => {
    btn.addEventListener("click", function(e){
      e.preventDefault();
      const key = this.dataset.fabricKey;
      tabButtons.forEach(b => b.classList.remove("active"));
      tabPanels.forEach(p => p.classList.remove("active"));
      this.classList.add("active");
      const activePanel = panel.querySelector(`.tab-panel[data-fabric-key="${key}"]`);
      if(activePanel) activePanel.classList.add("active");
    });
  });

  // --- 2. 核心逻辑：Ajax 加入购物车并锁定按钮状态 ---
  const addBtns = panel.querySelectorAll(".add-sample-btn");
  addBtns.forEach(btn => {
    btn.addEventListener("click", function(e){
      e.preventDefault();
      const variantId = this.dataset.variantId;
      if(!variantId) return;

      const _this = this;
      _this.innerText = "Adding...";
      _this.disabled = true; // 点击瞬间先行禁用，防止重复点击

      fetch("/cart/add.js", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ id: variantId, quantity: 1 })
      })
      .then(res => res.json())
      .then(data => {
        
        // A. 更新购物车数量显示 (.CartCount)
        fetch('/cart.js')
          .then(r => r.json())
          .then(cart => {
            const countLabels = document.querySelectorAll('.CartCount, #CartCountCavas');
            countLabels.forEach(label => {
              label.textContent = cart.item_count;
            });
          });

        // B. 更新右侧购物车列表内容 (#desktop_cart 内部的 #cart-info)
        fetch('/cart?view=json')
          .then(response => response.text())
          .then(html => {
            const cartInfo = document.getElementById('cart-info');
            if (cartInfo) {
              cartInfo.innerHTML = html;
            }

            // C. 自动滑出右侧购物车面板 (参考 nuranium.js 逻辑)
            const desktopCart = document.getElementById('desktop_cart');
            const sidebarOverlay = document.querySelector('.sidebar-overlay');
            if (desktopCart) {
              desktopCart.classList.add('active');
              desktopCart.classList.add('item_count');
            }
            if (sidebarOverlay) sidebarOverlay.classList.add('act');
            
            // D. 永久改变当前面料按钮状态
            _this.innerText = "Added";
            _this.disabled = true; // 保持禁用状态
            _this.style.opacity = "0.6"; // 增加视觉反馈
            _this.style.cursor = "not-allowed";
          });
      })
      .catch(err => {
        console.error("Cart Update Error:", err);
        _this.innerText = "Error";
        _this.disabled = false; // 如果报错，允许用户再次尝试
      });
    });
  });

});